module.exports = __webpack_public_path__ + "img/30days.36050b56.svg";